export const capitaliseFirstLetter = (word) =>
  word.slice(0, 1).toUpperCase() + word.slice(1);
